
import SMSIcon from "../assets/icons/Group 632.svg";

const CopyIcon = () => {
       return (
              <svg xmlns="http://www.w3.org/2000/svg" width="14" height="17.164" viewBox="0 0 14 17.164">
                     <g id="clipboard" transform="translate(-3.15 -1.15)">
                            <g id="Group_2755" data-name="Group 2755" transform="translate(3.15 1.15)">
                                   <path id="Path_2087" data-name="Path 2087" d="M14.9,18.732H5.4A2.257,2.257,0,0,1,3.15,16.478V5.4A2.257,2.257,0,0,1,5.4,3.15H6.986a.672.672,0,1,1,0,1.345H5.4a.911.911,0,0,0-.91.91V16.478a.911.911,0,0,0,.91.91H14.9a.911.911,0,0,0,.91-.91V5.4a.911.911,0,0,0-.91-.91H13.314a.672.672,0,1,1,0-1.345H14.9A2.257,2.257,0,0,1,17.15,5.4V16.478A2.257,2.257,0,0,1,14.9,18.732Z" transform="translate(-3.15 -1.568)" fill="#212121" />
                                   <path id="Rectangle_1021" data-name="Rectangle 1021" d="M.613-.85H5.359A1.465,1.465,0,0,1,6.822.613V2.2A1.465,1.465,0,0,1,5.359,3.658H.613A1.465,1.465,0,0,1-.85,2.2V.613A1.465,1.465,0,0,1,.613-.85ZM5.359,2.314A.119.119,0,0,0,5.478,2.2V.613A.119.119,0,0,0,5.359.495H.613A.119.119,0,0,0,.495.613V2.2a.119.119,0,0,0,.119.119Z" transform="translate(4.014 0.85)" fill="#212121" />
                            </g>
                     </g>
              </svg>
       )
}

const SendIcon = () => {
       return (
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16">
                     <g id="send" transform="translate(-1.15 -1.15)">
                            <g id="Group_2696" data-name="Group 2696" transform="translate(1.15 1.15)">
                                   <path id="Path_2023" data-name="Path 2023" d="M10.777,10.514a.627.627,0,0,1-.443-1.07l8.111-8.111a.627.627,0,1,1,.886.886L11.22,10.33A.625.625,0,0,1,10.777,10.514Z" transform="translate(-3.514 -1.15)" fill="#212121" />
                                   <path id="Path_2024" data-name="Path 2024" d="M16.523,1.15a.627.627,0,0,1,.592.834L11.954,16.73a.627.627,0,0,1-1.164.047L7.938,10.362,1.522,7.511A.627.627,0,0,1,1.57,6.346L16.316,1.185A.626.626,0,0,1,16.523,1.15ZM11.293,14.824,15.5,2.8,3.476,7.007,8.667,9.315a.627.627,0,0,1,.318.318Z" transform="translate(-1.15 -1.15)" fill="#212121" />
                            </g>
                     </g>
              </svg>
       )
}



export {
       SMSIcon,
       CopyIcon,
       SendIcon
}